import { useQuery } from 'react-query';

import {
  FORUM_POSTS_KEY,
  ForumPostOptions,
  ForumPostsResult,
  getForumPosts,
} from '@utils/backend-api/forumPosts';
import { PaginationType } from '@utils/backend-api/subscriber_directory';

// TODO: move this to its own module
export const setPagination = (data: PaginationType) => {
  const { hasNextPage, nextPage, page, totalCount, totalPages } = data;
  return { hasNextPage, nextPage, page, totalCount, totalPages };
};

export default function useForumPosts({
  onSearchPage = false,
  order = null,
  page = 1,
  perPage = 50,
  topic,
}: ForumPostOptions) {
  const { data, isLoading: areForumPostsLoading } = useQuery<ForumPostsResult>(
    [FORUM_POSTS_KEY, page, order, topic],
    () => getForumPosts({ page, perPage, order, topic, onSearchPage }),
    { keepPreviousData: true }
  );

  const pagination: PaginationType = data
    ? setPagination(data)
    : {
        hasNextPage: false,
        nextPage: 0,
        page: 0,
        totalPages: 0,
      };

  return { data, forumPosts: data?.forum_posts, areForumPostsLoading, pagination };
}
